/* import __COLOCATED_TEMPLATE__ from './content-group.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();